import Bloc from "./Bloc";
export default Bloc;
